var CompanyStateChange = /** @class */ (function () {
    function CompanyStateChange() {
        this.companyId;
        this.companyState;
        this.note;
        this.userId;
        this.techAssessmentLimitForSoftHold;
        // this.jbiLimitForSoftHold;
    }
    return CompanyStateChange;
}());
export { CompanyStateChange };
//# sourceMappingURL=change-company-state.model.js.map